export function getNoResultsMessage(no_results, no_results_ex, formData) {
  if (!no_results_ex) {
    return no_results;
  }
  // Find all placeholders in no_results_ex like {variable}
  const matches = [...no_results_ex.matchAll(/\{(\w+)\}/g)].map((m) => m[1]);

  // Check if all variables exist in formData
  const allAvailable = matches.every((key) => key in formData);

  if (!allAvailable) {
    return no_results;
  }

  // Interpolate variables from formData
  return no_results_ex.replace(/\{(\w+)\}/g, (_, key) => formData[key]);
}
